import moment from "moment";

import { Header, Icon } from "semantic-ui-react";

import offerStatuses from "astrid-firestore/src/api/offers/constants/offerStatuses";

import Flex from "../../../../../components/Flex/Flex";

import useNotificationHeaderTranslations from "../../../hooks/useNotificationHeaderTranslations";

export default function NotificationHeader({ todo }) {
	const { type, createdAt, content } = todo;

	const headerTranslations = useNotificationHeaderTranslations(todo);

	return (
		<Header style={{ margin: "0 0 7px 0", fontSize: 16 }}>
			{content.offer?.status === offerStatuses.DECLINED ? (
				<Flex justifyContent="flex-start" alignItems="center" gap={3}>
					{headerTranslations[type]}

					<div>
						<Icon name="attention" color="red" style={{ fontSize: 14 }} />
					</div>
				</Flex>
			) : (
				<div>{headerTranslations[type]}</div>
			)}

			<span style={{ color: "grey", fontSize: 13, marginLeft: 5, fontWeight: 400 }}>
				{moment(createdAt.toDate()).fromNow()}
			</span>
		</Header>
	);
}
